import React from 'react';
import TentComponent from '../components/Tent';

const Tent = () => {
    return (
        <div>
            <TentComponent />
        </div>
    );
};

export default Tent;
